// frontend/src/api/CNASTDPIGEFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNASTDPIXEFiles = async () => {
  try {
    const response = await api.get("/cna-std-pixe-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA STD PIXE file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNASTDPIXEFileById = async (id) => {
  try {
    const response = await api.get(`/cna-std-pixe-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA STD PIXE file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNASTDPIXEFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-std-pixe-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNASTDPIXEFiles = async (query) => {
  try {
    const response = await api.get(`/cna-std-pixe-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA STD PIXE files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNASTDPIXEFile = async (data) => {
  try {
    const response = await api.post("/cna-std-pixe-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA STD PIXE file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNASTDPIXEFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-std-pixe-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA STD PIXE file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNASTDPIXEFile = async (id) => {
  try {
    const response = await api.delete(`/cna-std-pixe-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA STD PIXE file:", error);
    throw error;
  }
};

// Exportar archivos CNA_STD_PIGE_File por ID
export const exportCNASTDPIXEFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-std-pixe-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA STD PIXE files by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNASTDPIXEFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-std-pixe-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA STD PIXE files:", error);
    throw error;
  }
};
